import React from 'react'
import './Heading.css'

function Heading({ heading }) {
  return <h1 className='heading'>{heading}</h1>
}

export default Heading
